(function() {
	'use strict';

	angular.module('agentApp').controller('AgentInfoController',
			AgentInfoController);

	AgentInfoController.$inject = [ '$scope', '$window', 'AgentInfoService', '$log', 'AlertService','NgTableParams', 
	                          '$state', '$stateParams', 'authExpiredInterceptor', '$filter', 'PolicyService', 'Upload','entity', '$base64', '$uibModal', 'AGENT_CONST', 'FileNetService'];

	function AgentInfoController($scope, $window, AgentInfoService, $log, AlertService, NgTableParams, 
			$state, $stateParams, authExpiredInterceptor, $filter, PolicyService, Upload, entity, $base64, $uibModal, AGENT_CONST, FileNetService) {
		var agentInfoCtr = this;
		var self = $scope;
		var param = $stateParams;
		self.loading = false;
		self.agentInfo = {};
		self.agentInfo.agentType = 'OBO';
		self.isDisable = false;
		self.agentInfo.requestTypeCode = AGENT_CONST.REQUEST_TYPE_CODE;
		self.agentInfo.requestTypeName = AGENT_CONST.REQUEST_TYPE_NAME;
		self.agentInfo.requestSubTypeCode = AGENT_CONST.REQUEST_SUB_TYPE_CODE;
		self.agentInfo.requestSubTypeName = AGENT_CONST.REQUEST_SUB_TYPE_NAME;
		function init(){
		}
		init();
		// Save CFI
		agentInfoCtr.doSaveAgent = function() {
			self.clearMessage();
			var data = [];
			var files=[];
			self.loading=true;
			if (self.agentInfo.attachmentReg && self.agentInfo.attachmentImg) {
				data['agentInfoDTO'] = new Blob([ JSON
						.stringify(self.agentInfo) ], {
					type : "application/json"
				});
				data['attachmentReg'] = self.agentInfo.attachmentReg;
				data['attachmentImg'] = self.agentInfo.attachmentImg;
			}
			Upload.upload(
			{
				url : GLOBAL_URL
						+ 'api/ga/agent-info/do-save-agent-info?access_token='
						+ authExpiredInterceptor.getToken(),
				data : data
			}).then(
			function(resp) {
				self.loading=false;
				if(resp.data != null && resp.data.status == '1'){
					self.agentInfoId = null;
					self.agentInfo.agentName = '';
					self.agentInfo.agentIdNum = '';
					self.agentInfo.attachmentReg=null;
					self.agentInfo.attachmentImg=null;
				}
			},
			function(resp) {
				self.loading=false;
			},
			function(evt) {
				/*var progressPercentage = parseInt(100.0
						* evt.loaded / evt.total);
				$log.debug('progress: ' + progressPercentage + '% '
						+ evt.config.data.file.name);*/
			});
				
		} 
		// repeat txn
		agentInfoCtr.reset = function(){
     		//https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
    		self.isDisable = false;
    		self.policyProposalNumDisable = false;
    		self.clearMessage();
     		$state.transitionTo($state.current, {}, { 
   			  reload: true, inherit: false, notify: true
   			});
     	}  
		
		//  ------------------
		agentInfoCtr.datePickerOpenStatus = {};
		agentInfoCtr.datePickerOpenStatus.fromDate = false;
		agentInfoCtr.datePickerOpenStatus.toDate = false;
		agentInfoCtr.openCalendar = openCalendar;
        function openCalendar (date) {
        	agentInfoCtr.datePickerOpenStatus[date] = true;
        }
        agentInfoCtr.dateOptions = {
				//maxDate : new Date()
		};
        agentInfoCtr.openFromDate = function() {
        	agentInfoCtr.popupFromDate.opened = true;
		};

		self.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		self.format = $scope.formats[2];
		self.altInputFormats = [ 'M!/d!/yyyy' ];
		agentInfoCtr.popupFromDate = {
			opened : false
		};

	}

})();
